// extracted by mini-css-extract-plugin
module.exports = {"root":"az_XX","disabled":"az_YX","edgeStart":"az_ZX","edgeEnd":"az__X","colorInherit":"az_aY","colorPrimary":"az_bY","colorSecondary":"az_cY","sizeSmall":"az_dY","label":"az_eY"};